import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseServiceFacade, GenericApiCall } from '../../../common/store/types';
import { AppState } from '../types';
import { ClaimTypeModel } from './types';
import { claimTypeActions } from './claim-type.actions';
import { claimTypeSelectors } from './claim-type.selector';

@Injectable()
export class ClaimTypeService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }

  getById: GenericApiCall<ClaimTypeModel, number> = this.genericApiCall(
    claimTypeActions.getById,
    claimTypeSelectors.getById,
    true,
  );
  createInstance: GenericApiCall<ClaimTypeModel, void> = this.genericApiCall(
    claimTypeActions.createInstance,
    claimTypeSelectors.createInstance,
    true,
  );
  add: GenericApiCall<ClaimTypeModel, ClaimTypeModel> = this.genericApiCall(
    claimTypeActions.add,
    claimTypeSelectors.add,
    true,
  );
  update: GenericApiCall<ClaimTypeModel, ClaimTypeModel> = this.genericApiCall(
    claimTypeActions.update,
    claimTypeSelectors.update,
    true,
  );
  delete: GenericApiCall<boolean, number> = this.genericApiCall(
    claimTypeActions.delete,
    claimTypeSelectors.delete,
    true,
  );
}
